import { type Log, type LogDispatchProps, type SetLogsProps } from 'src/types'

// consider adding props that last from game to game
const setLogs = ({ logs }: SetLogsProps) => logs

const deleteLogs = () => []

const addLog = (logs: Log[], { log }: LogDispatchProps) => [...logs.slice(), log]

const addLogs = (_logs: Log[], { logs }: LogDispatchProps) => [..._logs.slice(), ...logs.slice()]

export const reducer = (logs: Log[], action: LogDispatchProps) => {
  switch (action.type) {
    case 'SET_LOGS':
      return setLogs(action)
    case 'DELETE_LOGS':
      return deleteLogs()
    case 'ADD_LOG':
      return addLog(logs, action)
    case 'ADD_LOGS':
      return addLogs(logs, action)
    default:
      return logs
  }
}
